const SDK_VERSION = '7.114.0';

export { SDK_VERSION };
